<template>
	<div class="Anexo3">

		<h1>TABELAS DE MULTAS</h1>

		<table id="table-1" class="quadro">
			<caption>Valores das multas e embargo</caption>
			<colgroup>
				<col class="Row-Column-1" width="20%" />
				<col class="Row-Column-2" width="20%" />
				<col class="Row-Column-3" width="15%" />
				<col class="Row-Column-3" width="15%" />
				<col class="Row-Column-1" width="20%" />
				<col class="Row-Column-1" width="10%" />
			</colgroup>
			<thead>
				<tr class="Row-Column-4">
					<th>
						<p>Infração</p>
					</th>
					<th>
						<p>Especificação</p>
					</th>
					<th>
						<p>Valor</p>
					</th>
					<th>
						<p>Unidade</p>
					</th>
					<th colspan="2">
						<p>Base de Cálculo (a)</p>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr class="Row-Column-4">
					<td rowspan="8">
						<p>Execução da obra sem a licença ou seu desvirtuamento</p>
					</td>
					<td>
						<p>Edificação nova</p>
					</td>
					<td>
						<p>R$ 130,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área executada</p>
					</td>
					<td>
						<p>Pela área efetivamente irregular</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Reforma</p>
					</td>
					<td>
						<p>R$ 130,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área executada</p>
					</td>
					<td>
						<p>Pela área objeto da reforma.</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Requalificação</p>
					</td>
					<td>
						<p>R$ 130,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área executada</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Reconstrução</p>
					</td>
					<td>
						<p>R$ 130,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área executada</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Demolição</p>
					</td>
					<td>
						<p>R$ 18,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área executada</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Muro de arrimo</p>
					</td>
					<td>
						<p>R$ 65,00</p>
					</td>
					<td>
						<p>m linear</p>
					</td>
					<td>
						<p>medido na base do muro</p>
					</td>
					<td>
						<p>Medido ao longo do muro de arrimo.</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Movimento de terra</p>
					</td>
					<td>
						<p>R$ 6,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área executada</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Transporte de terra ou entulho</p>
					</td>
					<td>
						<p>R$ 390,00</p>
					</td>
					<td>
						<p>viagem</p>
					</td>
					<td>
						<p>viagem</p>
					</td>
					<td>
						<p>Por cada viagem</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td rowspan="7">
						<p>Falta de Alvará de Autorização ou seu desvirtuamento</p>
					</td>
					<td>
						<p>Implantação e/ou utilização de edificação transitória</p>
					</td>
					<td>
						<p>R$ 2.600,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Implantação e/ou utilização de equipamento transitório</p>
					</td>
					<td>
						<p>R$ 2.600,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Implantação de canteiro de obras em imóvel distinto</p>
					</td>
					<td>
						<p>R$ 2.600,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Implantação de estande de vendas em imóvel distinto</p>
					</td>
					<td>
						<p>R$ 1.300,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Avanço do tapume sobre parte do passeio público</p>
					</td>
					<td>
						<p>R$ 130,00</p>
					</td>
					<td>
						<p>m linear</p>
					</td>
					<td>
						<p>medido ao longo do alinhamento</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Avanço de grua sobre espaço público</p>
					</td>
					<td>
						<p>R$ 2.600,00</p>
					</td>
					<td>
						<p>unidade</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>Por cada grua que avance sobre o espaço público.</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td>
						<p>Utilização temporária de edificação licenciada para outro uso</p>
					</td>
					<td>
						<p>R$ 2.600,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-4">
					<td colspan="2">
						<p>Resistência ao embargo</p>
					</td>
					<td colspan="2">
						<p>10%</p>
					</td>
					<td>
						<p>multa correspondente à infração</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
			</tbody>
		</table>

		<hr>

		<table id="table-2" class="quadro">
			<caption>Valores das demais multas</caption>
			<colgroup>
				<col class="Row-Column-1" width="20%" />
				<col class="Row-Column-2" width="20%" />
				<col class="Row-Column-3" width="15%" />
				<col class="Row-Column-3" width="10%" />
				<col class="Row-Column-1" width="15%" />
				<col class="Row-Column-1" width="20%" />
			</colgroup>
			<thead>
				<tr class="Row-Column-4">
					<th>
						<p>Infração</p>
					</th>
					<th>
						<p>Especificação</p>
					</th>
					<th>
						<p>Valor</p>
					</th>
					<th>
						<p>Unidade</p>
					</th>
					<th colspan="2">
						<p>Base de Cálculo (a)</p>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr class="Row-Column-5">
					<td rowspan="3">
						<p>Falta de cadastro, manutenção ou seu desvirtuamento</p>
					</td>
					<td>
						<p>Equipamento mecânico de transporte permanente, incluindo elevadores</p>
					</td>
					<td>
						<p>R$ 390,00</p>
					</td>
					<td>
						<p>unidade</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>Por equipamento que deveria ser cadastrado.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td>
						<p>Tanque de armazenagem, bomba, filtro de combustível e equipamentos afins</p>
					</td>
					<td>
						<p>R$ 390,00</p>
					</td>
					<td>
						<p>unidade</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>Por equipamento que deveria ser cadastrado.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td>
						<p>Sistema especial de segurança</p>
					</td>
					<td>
						<p>R$ 7,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área utilizada</p>
					</td>
					<td>
						<p>Pela área utilizada pelo Sistema Especial de Segurança.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td rowspan="3">
						<p>Existência de edificação sem o Certificado</p>
					</td>
					<td>
						<p>Certificado de Conclusão</p>
					</td>
					<td>
						<p>R$ 200,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área objeto de <br />intervenção</p>
					</td>
					<td>
						<p>Desconsiderar a área objeto de Certificado de Conclusão anterior.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td>
						<p>Certificado de Acessibilidade</p>
					</td>
					<td>
						<p>R$ 200,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área objeto de intervenção</p>
					</td>
					<td>
						<p>Pela área a ser adaptada às condições de acessibilidade.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td>
						<p>Certificado de Segurança</p>
					</td>
					<td>
						<p>R$ 200,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área objeto de intervenção</p>
					</td>
					<td>
						<p>Pela área a ser adaptada às condições de segurança.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td colspan="2">
						<p>Resistência à interdição</p>
					</td>
					<td>
						<p>R$ 50,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área interditada</p>
					</td>
					<td>
						<p>Pela área objeto da interdição.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td colspan="2">
						<p>Descumprimento da intimação prevista no art. 87</p>
					</td>
					<td>
						<p>R$ 150,00</p>
					</td>
					<td>
						<p>m²</p>
					</td>
					<td>
						<p>área interditada</p>
					</td>
					<td>
						<p>Pela área objeto da interdição.</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td colspan="2">
						<p>Falta de documento no local da obra ou serviço</p>
					</td>
					<td>
						<p>R$ 1.300,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-5">
					<td colspan="2">
						<p>Demais infrações às disposições do COE, cujo valor não conste desta tabela.</p>
					</td>
					<td>
						<p>R$ 500,00</p>
					</td>
					<td>
						<p>valor fixo</p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default{
	name: "Anexo3", 
	data(){
		return{
			title: "Anexo 3",
			props:['caminho']

		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Anexo3.vue